import * as Dialog from '@radix-ui/react-dialog';

import { styled } from '@lichtblick/styled';
import { Colors, Spacing } from '@lichtblick/theme';

export const Content = styled(Dialog.Content)`
  align-items: center;
  background: ${Colors.white};
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: ${Spacing.Xs};
  justify-content: center;
  left: 0;
  margin: auto;
  max-width: 60.75rem;
  padding: ${Spacing.L} ${Spacing.S};
  position: relative;
  top: 0;
  width: 90%;
`;

export const ActionsContainer = styled.div<{ controlLayout: 'center' | 'left' | 'right' }>`
  display: flex;
  flex-direction: row;
  gap: ${Spacing.Xs};
  margin-top: 1rem;
  ${({ controlLayout }) => {
    switch (controlLayout) {
      case 'left':
        return 'margin-right: auto;';
      case 'right':
        return 'margin-left: auto; flex-direction: row-reverse;';
      case 'center':
      default:
        return '';
    }
  }}
`;
